import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { TipuriDocumente, TipuriDocumenteEditPayload } from '../tipuri-documente.interface';
import { TipuriDocumenteService } from '../tipuri-documente.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, Observable } from 'rxjs';
import { CategoriiDocumenteService } from '../../categorii-documente/categorii-documente.service';
import { Generic } from 'src/app/interfaces/generic.interface';

@Component({
    selector: 'app-edit-tipuri-documente',
    templateUrl: './edit-tipuri-documente.component.html',
    styleUrls: ['./edit-tipuri-documente.component.scss']
})
export class EditTipuriDocumenteComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;
    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        id_group: new FormControl(this.data.id_group, [Validators.required]),
        slug: new FormControl(this.data.slug, [Validators.required]),
        observations: new FormControl(this.data.observations),
    });

    categoriiDocumente$!: Observable<Generic[]>;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: TipuriDocumenteEditPayload,
        private dialogRef: MatDialogRef<EditTipuriDocumenteComponent>,
        private tipuriDocumenteService: TipuriDocumenteService,
        private categoriiDocumenteService: CategoriiDocumenteService,
        private notificationService: NotificationService,
        private authService: AuthService,
    ) {
        this.processToken();
    }

    ngOnInit() {
        this.loadCategorii();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.categoriiDocumenteService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, id_group, slug, observations } = this.form
            .value as TipuriDocumente;
        const updateStatus: TipuriDocumenteEditPayload = {
            id: this.data.id,
            name,
            id_group,
            slug,
            observations,
        };

        this.tipuriDocumenteService
            .updateTip(updateStatus)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    onHttpError(res: any) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                this.notificationService.warningSwal(
                    this.errorTitle,
                    msg,
                    this.errorIcon
                );
            });
        } else {
            let msg;
            try {
                // try to catch the message from server
                msg = res.error.errors.message[0];
            } catch (error) {
                // controll output message
                msg = helper.dialogConfig.generalMessages.error;
            }
            this.notificationService.warningSwal(
                this.errorTitle,
                msg,
                this.errorIcon
            );
        }
    }

    loadCategorii() {
        this.isLoading = true;
        this.categoriiDocumente$ = this.categoriiDocumenteService
            .getCategoriiDocumenteActive()
            .pipe(finalize(() => (this.isLoading = false)));
    }
}
